// 公共配置
const envType = process.env.VUE_APP_ENV_TYPE

// http/https环境枚举
const HTTP_ENV_ENUM = {
  dev: '/api', // 开发环境
  preview: 'api/', // 预发布环境
  prod: 'api/', // 正式环境
  test: 'api/' // 测试环境
}
const IMG_ENV_ENUM = {
  dev: '', // 开发环境
  preview: '', // 预发布环境
  prod: '', // 正式环境
  test: ''
}

const SITE_ENV_ENUM = {
  dev: 'http://localhost:8080',
  prod: 'https://wechat.ai101.cn'
}

export default {
  baseUrl: HTTP_ENV_ENUM[envType],
  site: SITE_ENV_ENUM[envType],
  imgUrl: IMG_ENV_ENUM[envType],
  publicPath: [/^\/public/], // 不用token页面
  useI18n: 'zh-CN' // 是否使用多语言，目前只支持中英文[zh-CN,en-US]
}
